import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CalendarClock, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DailyRollingToggle = ({ booking, token, onSaved }) => {
  const [busy, setBusy] = useState(false);
  if (booking.status === "cancelled") return null;
  const dr = booking.daily_rolling || {};
  const on = !!dr.enabled;
  const today = new Date().toISOString().slice(0, 10);
  const due = on && (dr.paid_through || "").slice(0, 10) <= today;

  const toggle = async () => {
    let rate = Number(dr.daily_rate) || 0;
    if (!on) {
      const v = window.prompt(`Turn ON Daily Rolling Rental for ${booking.name}?\n\nEnter their daily rate ($ per day). Every payment then buys the next day — paid-through and return date advance automatically, no formal extension needed.`, rate ? String(rate) : "75");
      if (v === null) return;
      rate = Number(v);
      if (!rate || rate <= 0) { toast.error("Enter a valid daily rate."); return; }
    } else if (!window.confirm(`Turn OFF Daily Rolling for ${booking.name}?`)) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/bookings/${booking.id}/daily-rolling`,
        { enabled: !on, daily_rate: rate, paid_through: (dr.paid_through || booking.return_date || "").slice(0, 10) },
        { headers: { Authorization: `Bearer ${token}` } });
      toast.success(!on
        ? `Daily Rolling is ON — $${Number(data.daily_rolling.daily_rate).toFixed(2)}/day, paid through ${data.daily_rolling.paid_through}. Manage it in Financial Actions below.`
        : "Daily Rolling turned OFF.");
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not update Daily Rolling.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button data-testid={`daily-rolling-toggle-${booking.id}`} onClick={toggle} disabled={busy}
      className={`text-xs flex items-center gap-1.5 px-3 py-1.5 rounded border transition-colors disabled:opacity-50 ${due
        ? "border-red-500 bg-red-500/15 text-red-300 hover:brightness-125"
        : on
          ? "border-[#F2B705] bg-[#F2B705]/15 text-[#F2B705] hover:brightness-125"
          : "border-white/20 text-white/60 hover:border-[#F2B705]/60 hover:text-[#F2B705]"}`}>
      {busy ? <Loader2 className="animate-spin" size={13} /> : <CalendarClock size={13} />}
      {on ? `Daily Rolling: $${Number(dr.daily_rate).toFixed(0)}/day${due ? " — PAYMENT DUE" : ""}` : "Daily Rolling: OFF"}
    </button>
  );
};

export default DailyRollingToggle;
